import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CONFIGS_WITH_SUBCONFIGS,
  DEFAULT_TABLE_PAGESIZE,
  EVENT_SEVERITY_TYPE_LIST,
  HIGH_COLOR,
  INCIDENT_QUICK_ACTION_MENU_ITEM,
  LOW_COLOR,
  MEDIUM_COLOR,
  SAFETY_EVENT_COLUMN_OPTION,
  SAFETY_EVENT_PAGE_OPTION,
  speedSignTag,
} from '@app-core/constants/constants';
import { AssetAutoCompleteResponseObject, ChildConfigs } from '@app-core/models/core.model';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { DateService } from '@app-core/services/date/date.service';
import { GoogleTagManagerService } from '@app-core/services/google-tag-manager/google-tag-manager.service';
import { SnackBarService } from '@app-core/services/snackbar/snack-bar.service';
import { UpdateIncidentsFilter } from '@app-incidents/actions/incidents-filter.actions';
import { getIncidentsFilter, getIncidentsViewType, State } from '@app-incidents/reducers';
import { IncidentModalComponent } from '@app-shared/components/incident-modal/incident-modal.component';
import { getSideNavigationConfigState } from '@app-shared/reducers';
import { CLIENT_CONFIG } from '@config/config';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { finalize, takeUntil, delay, skip, map, tap } from 'rxjs/operators';
import { MixPanelService } from '@app-core/services/mixpanel/mix-panel.service';
import { MatTableDataSource } from '@angular/material/table';
import { IncidentDetailsParams, ModifiedEventListIncidents, SafetyEventsPageQueryParams } from '@app-incidents/models/incidents.models';
import { MatSort } from '@angular/material/sort';
import { UserManageService } from '@app-user-management/services/user-manage/user-manage.service';
import { UpdateUserMetadataReqBody } from '@app-user-management/models/users.model';
import { UpdateIncidentViewType } from '@app-incidents/actions/incident-view-type.action';
import { SelectionModel } from '@angular/cdk/collections';
import { StorageService } from '@app-core/services/storage/storage.service';
import { IncidentsService } from '@app-incidents/services/incidents.service';
import { DownloadService } from '@app-shared/services/common/download.service';

export function debounce(delay: number = 300): MethodDecorator {
  return function (target: any, propertyKey: string | symbol, descriptor: PropertyDescriptor) {
    const timeoutKey = Symbol();
    console.log(target, propertyKey);
    const original = descriptor.value;

    descriptor.value = function (...args: any) {
      clearTimeout(this[timeoutKey]);
      this[timeoutKey] = setTimeout(() => original.apply(this, args), delay);
    };

    return descriptor;
  };
}
@Component({
  selector: 'app-incidents',
  templateUrl: './incidents.component.html',
  styleUrls: ['./incidents.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class IncidentsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(CdkVirtualScrollViewport) virtualScroll: CdkVirtualScrollViewport;
  @ViewChild('fleetIncidentsRef', { read: ElementRef }) public fleetIncidentsRef: ElementRef;
  @ViewChild(MatPaginator, { static: true })
  public paginator: MatPaginator;
  @ViewChild('sort', { static: true }) public sort: MatSort;
  public dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private ngUnsubscribeOnChanges: Subject<void> = new Subject<void>();
  private unsubscribeOnDestroy: Subject<void> = new Subject<void>();

  public loader = false;
  public fleetIncidentsDataSource = [];
  public fleetIncidentsList = [];
  public carouselContainerWidth = 0;
  public carouselCardWidth = 0;
  public pageSize = 5;
  public loaderCards = [];
  public driverList = [];
  public startDate: string;
  public endDate: string;
  public driverId: string;
  public asset: AssetAutoCompleteResponseObject;
  public eventType: string;
  public offset = 0;
  public limit = 0;
  public endOfList = false;
  public rowCount = 4;
  public filterType: string;
  public tagIds: string[];
  public selectVideoType: string;
  public subEventType: string;
  public modifiedEventList: ModifiedEventListIncidents[] = [];
  public clientConfig = CLIENT_CONFIG;
  public isListView: boolean = false;
  public isFilterVisible: boolean = true;
  public totalEvents: number = 0;
  public displayedColumns: string[] = SAFETY_EVENT_COLUMN_OPTION;
  public pageSizeOptions: number[] = SAFETY_EVENT_PAGE_OPTION;
  public tablePageSize: number = DEFAULT_TABLE_PAGESIZE;
  public sortvalue = 'desc';
  public eventTypeChanged: string = '';
  public sortColumn = 'timestamp';
  public selection = new SelectionModel<any>(true, []);
  public selectedIncident: any = null;
  public selectedEvents: any = [];
  public menuItems = INCIDENT_QUICK_ACTION_MENU_ITEM;
  public selectedItem: { action: string; label: string };
  public selectedRowCount: number;
  public severity: string;
  public viewedStatus: string | boolean;
  public selectedCount: number;

  private isFirstLoad: boolean = true;

  constructor(
    private dialog: MatDialog,
    public dataService: DataService,
    private accessService: AccessService,
    private cdRef: ChangeDetectorRef,
    private store: Store<State>,
    private router: Router,
    private snackbarService: SnackBarService,
    public translate: TranslateService,
    private gtmService: GoogleTagManagerService,
    private dateService: DateService,
    private userManageService: UserManageService,
    private storageService: StorageService,
    private route: ActivatedRoute,
    private incidentsService: IncidentsService,
    private downloadService: DownloadService,
    private mixpanelService: MixPanelService
  ) {}

  public ngOnInit() {
    const combinedEventsList = this.dataService.modifyFleeEvents();
    this.modifiedEventList = combinedEventsList.map((k) => ({
      key: k['key'],
      label: k['label'],
      childConfigs: k['childConfigs'],
      isCollisionEvent: k.isCollisionEvent,
    }));
    const coachingConfig = this.storageService.getStorageValue('coachingConfig') || {};
    const enableSelectForCoaching = coachingConfig.eventTypes || [];
    if (enableSelectForCoaching.length === 0) {
      this.menuItems = this.menuItems.filter((item) => item.action !== 'SELECT_FOR_COACHING');
    } else {
      const coachingItem = { action: 'SELECT_FOR_COACHING', label: 'commonIncidentViewSelectForCoaching' };
      const index = this.menuItems.findIndex((item) => item.action === coachingItem.action);
      if (index !== -1) {
        this.menuItems.splice(index, 1);
      }
      this.menuItems.splice(1, 0, coachingItem);
    }

    this.parseQueryParams();

    this.store
      .select(getIncidentsFilter)
      .pipe(takeUntil(this.ngUnsubscribeOnChanges))
      .subscribe((incidentFilter) => {
        this.fleetIncidentsList = [];
        this.fleetIncidentsDataSource = [];
        this.endOfList = false;
        this.offset = 0;
        this.limit = this.isListView ? this.tablePageSize : this.pageSize * 4;
        const {
          paramStartDate,
          paramEndDate,
          driverId,
          asset,
          eventType,
          filterType,
          tagIds,
          selectVideoType,
          subEventType,
          viewStatus,
          severity,
        } = incidentFilter;
        this.startDate = paramStartDate;
        this.endDate = paramEndDate;
        this.asset = asset;
        this.driverId = driverId;
        this.eventType = eventType;
        this.filterType = filterType;
        this.tagIds = tagIds;
        this.selectVideoType = selectVideoType;
        this.subEventType = subEventType;
        this.viewedStatus = viewStatus;
        this.severity = severity;
        if (this.virtualScroll) {
          this.virtualScroll.scrollToIndex(0);
        }
        if (this.isListView) {
          if (!this.eventType) {
            this.sortvalue = 'desc';
            this.sortColumn = 'timestamp';
          }
          this.paginator.pageIndex = 0;
        }
      });

    this.dataService._currentFleet.pipe(takeUntil(this.ngUnsubscribe), skip(1)).subscribe((value: string) => {
      if (value) {
        this.fleetIncidentsList = [];
        this.fleetIncidentsDataSource = [];
        this.endOfList = false;
        this.offset = 0;
        this.limit = this.isListView ? this.tablePageSize : this.pageSize * this.rowCount;
        if (this.virtualScroll) {
          this.virtualScroll.scrollToIndex(0);
        }
        this.selectApiToCall();
        this.clearSelection();
      }
    });
    this.dataService._currentTablePageSize.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: number) => {
      if (value) {
        this.tablePageSize = value;
      }
    });

    this.store
      .select(getSideNavigationConfigState)
      .pipe(takeUntil(this.unsubscribeOnDestroy), delay(500))
      .subscribe(() => {
        this.checkCarouselConfiguration();
      });

    this.dataService.refreshIncidentsList$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.fleetIncidentsList = [];
      this.offset = 0;
      this.selectApiToCall(true);
    });

    this.paginator.page
      .pipe(
        takeUntil(this.ngUnsubscribe),
        tap((event) => {
          this.verifyAndUpdateTablePageSize(event as PageEvent);
        })
      )
      .subscribe((event: PageEvent) => {
        this.tablePageSize = event.pageSize;
        this.offset = event.pageIndex * this.tablePageSize;
        this.limit = this.tablePageSize;
        this.fleetIncidentsList = [];
        this.clearSelection();
        this.selectApiToCall();
      });

    this.store
      .select(getIncidentsViewType)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        this.isListView = res.isListView;
        if (this.isListView) {
          this.limit = this.tablePageSize;
        } else {
          this.limit = this.pageSize * 4;
          this.sortvalue = 'desc';
          this.sortColumn = 'timestamp';
        }
        this.totalEvents = 0;
        this.offset = 0;
        this.fleetIncidentsList = [];
        this.selectApiToCall();
      });
  }

  private parseQueryParams() {
    this.route.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params: SafetyEventsPageQueryParams) => {
      const { startTimeUTC, endTimeUTC, eventType, tripId, eventIndex, driverId } = params;

      let filterState: any = {};
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();
      const milliSeconds = now.getMilliseconds();

      const hasSubEvents = Boolean(this.incidentsService.getChildConfigs(eventType).length);
      const [parentEventType] = Object.entries(CONFIGS_WITH_SUBCONFIGS).find(([, subEvents]) => subEvents.includes(eventType)) || [];

      if (hasSubEvents) {
        const defaultSubEventType = this.incidentsService.getDefaultSubEventType(eventType);
        filterState.eventType = eventType;
        filterState.subEventType = defaultSubEventType;
      } else if (parentEventType) {
        filterState.eventType = parentEventType;
        filterState.subEventType = eventType;
      } else if (Object.keys(speedSignTag).includes(eventType)) {
        filterState.eventType = 'Traffic-Speed-Violated';
        filterState.subEventType = eventType;
      } else if (eventType) {
        filterState.eventType = eventType;
      }

      if (startTimeUTC) {
        // Setting current Hours, minutes and seconds since datepicker only sets date part.
        const startDate = new Date(startTimeUTC);
        const from = this.dateService.toDaysStartISO(new Date(startDate.setHours(hours, minutes, seconds, milliSeconds)));
        filterState = {
          ...filterState,
          displayStartDate: startDate,
          paramStartDate: from,
          days: 'custom',
        };
      }

      if (endTimeUTC) {
        // Setting current Hours, minutes and seconds since datepicker only sets date part.
        const endDate = new Date(endTimeUTC);
        const to = this.dateService.toDaysEndISOPlusOne(new Date(endDate.setHours(hours, minutes, seconds, milliSeconds)));
        filterState = {
          ...filterState,
          displayEndDate: endDate,
          paramEndDate: to,
          days: 'custom',
        };
      }

      if (tripId && driverId && eventIndex) {
        this.getIncidentDetailsAndOpenDialog({ tripId, driverId, eventIndex: Number(eventIndex) });
      }

      this.store.dispatch(new UpdateIncidentsFilter(filterState));

      if (!this.isFirstLoad) {
        this.selectApiToCall();
        this.clearSelection();
      }

      if (this.isFirstLoad) {
        this.isFirstLoad = false;
      }
    });
  }

  private selectApiToCall(isRefresh?: Boolean) {
    this.checkCarouselConfiguration();
    if (this.startDate && this.endDate && this.driverId && this.eventType && this.selectVideoType && this.subEventType) {
      this.asset = null;
      this.getFleetIncidents(isRefresh);
    } else if (this.startDate && this.endDate && this.driverId && this.selectVideoType) {
      this.asset = null;
      this.getFleetIncidents(isRefresh);
    } else if (this.startDate && this.endDate && this.asset) {
      this.driverId = '';
      this.getAssetIncidents(isRefresh);
    } else {
      this.getFleetIncidents(isRefresh);
    }
  }

  @HostListener('scroll', ['$event'])
  @debounce()
  onScroll(event: any) {
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight - 1 && !this.loader && !this.endOfList) {
      this.limit = this.pageSize * 4;
      this.offset = this.offset + this.limit;
      this.selectApiToCall();
    }
  }

  public ngAfterViewInit() {
    this.checkCarouselConfiguration();
    if (this.sort) {
      this.sort.sortChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
        this.sortvalue = res.direction;
        this.sortColumn = res.active;
        this.fleetIncidentsList = [];
        this.paginator.pageIndex = 0;
        this.offset = 0;
        this.selectApiToCall();
        this.dataSource.data = new Array(10).fill(undefined);
      });
      this.dataSource.sort = this.sort;
    }
  }

  public getChildConfigs(eventKey: string): ChildConfigs[] {
    const selectedEvent = this.modifiedEventList.find((event) => event.key === eventKey);
    if (selectedEvent && selectedEvent.childConfigs) {
      return Object.entries(selectedEvent.childConfigs).map(([key, value]: [string, { label: string }]) => ({ key, label: value.label }));
    }
    return [];
  }

  public async getFleetIncidents(isRefresh?: Boolean) {
    this.loader = true;
    const childConfigs: ChildConfigs[] = this.getChildConfigs(this.eventType);
    const params = {
      startDate: this.startDate,
      endDate: this.endDate,
      limit: this.limit,
      offset: this.offset,
      sortBy: this.sortColumn,
      sort: this.sortvalue,
      ...(this.driverId ? { driverId: this.driverId } : {}),
      ...this.getTagsQueryParams(),
      ...this.getEventConfigParams(childConfigs),
      ...(this.selectVideoType === 'UPLOADED' ? { status: this.selectVideoType } : {}),
      ...(this.viewedStatus != 'All' ? (this.viewedStatus ? { isViewed: true } : { isViewed: false }) : {}),
      ...(this.severity && this.severity.length ? { severityType: this.severity } : {}),
    };

    const api$ =
      params['eventType'] === 'PotentialCrash'
        ? this.dataService.getCriticalEvents(params, isRefresh)
        : this.dataService.getFleetIncidents(params, isRefresh);

    api$
      .pipe(
        map(({ rows = [], totalCount = 0 }) => this.mapIncidentSeverity(rows, totalCount)),
        finalize(() => {
          this.loader = false;
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(
        ({ rows = [], totalCount = 0 }) => {
          this.totalEvents = totalCount;
          this.endOfList = (!rows.length || rows?.length < this.limit) && this.fleetIncidentsList.length > 0;
          this.fleetIncidentsList = [...this.fleetIncidentsList, ...rows];
          this.fleetIncidentsDataSource = this.generateDataChunk(this.fleetIncidentsList, this.pageSize);
          this.dataSource.data = this.fleetIncidentsList;
        },
        () => {
          this.fleetIncidentsDataSource = [];
        }
      );
  }

  public getAssetIncidents(isRefresh?: Boolean) {
    this.loader = true;
    const childConfigs: ChildConfigs[] = this.getChildConfigs(this.eventType);
    const params = {
      startDate: this.startDate,
      endDate: this.endDate,
      assetId: this.asset.assetId,
      limit: this.limit * this.rowCount,
      offset: this.offset,
      sortBy: this.sortColumn,
      sort: this.sortvalue,
      ...this.getTagsQueryParams(),
      ...this.getEventConfigParams(childConfigs),
      ...(this.selectVideoType === 'UPLOADED' ? { status: this.selectVideoType } : {}),
      ...(this.viewedStatus != 'All' ? (this.viewedStatus ? { isViewed: true } : { isViewed: false }) : {}),
      ...(this.severity && this.severity.length ? { severityType: this.severity } : {}),
    };

    const api$ =
      params['eventType'] === 'PotentialCrash'
        ? this.dataService.getCriticalEvents(params, isRefresh)
        : this.dataService.getAssetIncidents(params, isRefresh);

    api$
      .pipe(
        map(({ rows = [], totalCount = 0 }) => this.mapIncidentSeverity(rows, totalCount)),
        finalize(() => {
          this.loader = false;
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(
        ({ rows = [], totalCount = 0 }) => {
          this.totalEvents = totalCount;
          this.endOfList = (!rows.length || rows?.length < this.limit) && this.fleetIncidentsList.length > 0;
          this.fleetIncidentsList = [...this.fleetIncidentsList, ...rows];
          this.fleetIncidentsDataSource = this.generateDataChunk(this.fleetIncidentsList, this.pageSize);
          this.dataSource.data = this.fleetIncidentsList;
        },
        () => {
          this.fleetIncidentsDataSource = [];
        }
      );
  }

  public getEventConfigParams(childConfigs: ChildConfigs[]) {
    let params = {};
    const arrayOfSpeedSignTags = Object.keys(speedSignTag);
    if (childConfigs.length > 0) {
      if (arrayOfSpeedSignTags.includes(this.subEventType)) {
        params['eventType'] = this.eventType;
        params['speedSignTag'] = this.subEventType;
      } else if (this.subEventType !== childConfigs[0].key) {
        params['eventType'] = this.subEventType;
      } else {
        params['eventType'] = this.eventType;
      }
    } else if (this.eventType) {
      params['eventType'] = this.eventType;
    }
    return params;
  }

  public checkCarouselConfiguration() {
    if (this.virtualScroll) {
      const elRef = this.virtualScroll.getElementRef();
      this.rowCount = Math.ceil(elRef.nativeElement.offsetWidth / 300);
    }
    if (this.fleetIncidentsRef && this.fleetIncidentsRef.nativeElement) {
      this.carouselContainerWidth = this.fleetIncidentsRef.nativeElement.offsetWidth;
      this.calculateSlidesToShowOnScreen();
      this.cdRef.detectChanges();
    }
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();

    this.ngUnsubscribeOnChanges.next();
    this.ngUnsubscribeOnChanges.complete();
    this.unsubscribeOnDestroy.next();
    this.unsubscribeOnDestroy.complete();
  }

  public showMedia(event: any = {}) {
    event.showSnackbar = false;
    this.mixpanelService.track('View Safety Events - Incident Video', {
      'Event Type Label': event.eventTypeLabel,
    });
    if (!event.isViewed) {
      this.updateIncident(event.tripId, [event], 'VIEWED_STATUS', event.index);
    }

    // modifying data for show only viewable pages
    this.dialog.open(IncidentModalComponent, {
      panelClass: ['incident-modal', 'mobile-modal'],
      position: { top: '24px', bottom: '24px' },
      autoFocus: false,
      disableClose: true,
      data: {
        source: 'IncidentView',
        allEvents: [event],
        currentIndex: 0,
        hidePagination: true,
      },
    });
  }

  public onIncidentsFilterChange(incidentsFilter: any) {
    const {
      driverId: newDriverId = '',
      paramStartDate: newStartDate = '',
      paramEndDate: newEndDate = '',
      displayStartDate = null,
      displayEndDate = null,
      asset: newAsset = null,
      eventType: newEventType = '',
      filterType: newFilterType = 'driverFilter',
      gtmEventType,
    } = incidentsFilter || {};
    const oldDriverId = this.driverId;
    const oldAsset = this.asset ? this.asset : null;
    const oldStartDate = this.startDate;
    const oldEndDate = this.endDate;
    const oldEventType = this.eventType;
    const oldFilterType = this.filterType;

    const isDriverIdChanged = newDriverId !== oldDriverId;
    const isTimeRangeChanged = newStartDate !== oldStartDate || newEndDate !== oldEndDate;
    const isEventTypeChanged = newEventType !== oldEventType;
    const isAssetIdChanged = newAsset?.assetId !== oldAsset?.assetId;
    const isFilterTypeChanged = oldFilterType !== newFilterType;

    if (isTimeRangeChanged) {
      const noOfDays = this.dateService.getNoOfDays(newStartDate, newEndDate);
      const durationInText = this.dateService.getDurationText(displayStartDate, displayEndDate, noOfDays);
      this.gtmService.changeIncidentsViewDurationTypeFilter(durationInText, noOfDays);
    }
    if (isFilterTypeChanged) {
      this.gtmService.changeIncidentsViewFilterTypeFilter(newFilterType);
    }
    if (isEventTypeChanged) {
      this.gtmService.changeIncidentsViewViolationTypeFilter(gtmEventType || 'All');
    }
    if (newFilterType === 'driverFilter' && isDriverIdChanged && newDriverId) {
      this.gtmService.changeIncidentsViewDriverTypeFilter(newDriverId || 'All Drivers');
    }
    if (newFilterType === 'assetFilter' && isAssetIdChanged) {
      this.gtmService.changeIncidentsViewAssetTypeFilter(newAsset?.assetId || 'All Assets');
    }
    this.updateQueryParams(incidentsFilter);
    this.store.dispatch(new UpdateIncidentsFilter(incidentsFilter));
  }

  private updateQueryParams(incidentsFilter: any) {
    const {
      displayStartDate: newStartDate = '',
      displayEndDate: newEndDate = '',
      eventType: newEventType = '',
      subEventType: newSubEventType = '',
    } = incidentsFilter || {};

    const hasSubEvents = Boolean(this.incidentsService.getChildConfigs(newEventType).length);
    const defaultSubEventType = this.incidentsService.getDefaultSubEventType(newEventType);
    const newQueryParams: SafetyEventsPageQueryParams = {
      startTimeUTC: new Date(newStartDate).toISOString(),
      endTimeUTC: new Date(newEndDate).toISOString(),
    };
    if (defaultSubEventType === newSubEventType) {
      newQueryParams.eventType = newEventType;
    } else if (hasSubEvents) {
      newQueryParams.eventType = newSubEventType;
    } else if (newEventType) {
      newQueryParams.eventType = newEventType;
    }

    this.router.navigate([], {
      queryParams: newQueryParams,
    });
  }

  public calculateSlidesToShowOnScreen() {
    const { carouselCardWidth, totalCardsInDisplay } = this.dataService.getCarouselConfiguration(this.carouselContainerWidth);
    this.carouselCardWidth = carouselCardWidth - 20;
    this.loaderCards = new Array(this.pageSize).fill(undefined);
    this.pageSize = totalCardsInDisplay;
  }

  public pageEvent(event: any) {
    if (event) {
      this.loader = true;

      setTimeout(() => {
        this.loader = false;
      }, 500);
    }
  }

  public coachIncident(tripId, events: any, index) {
    events.forEach((incidentDetails) => {
      const { eventTypeLabel } = incidentDetails;
      this.mixpanelService.track('Clicked select for coaching in safety events page', {
        'Event Type': eventTypeLabel,
      });
      this.gtmService.coachinginIncidentViewList(incidentDetails.eventTypeLabel, incidentDetails.asset.assetId);
    });
    this.updateIncident(tripId, events, 'COACHING', index);
  }

  public discardIncident(tripId, events: any, index) {
    events.forEach((incidentDetails) => {
      const { eventTypeLabel } = incidentDetails;
      this.mixpanelService.track('Clicked discard event in safety events page', {
        'Event Type': eventTypeLabel,
      });
      this.gtmService.discardIncidentInIncidentViewList(incidentDetails.eventTypeLabel, incidentDetails.asset.assetId);
    });
    this.updateIncident(tripId, events, 'REPORT_BUG', index);
  }

  public viewTripDetails(incident: any) {
    this.gtmService.gotoTripDetailsFromIncidentsViewList(incident.eventTypeLabel, incident.asset.assetId);
    this.router.navigate(['/trip-details'], {
      queryParams: {
        tripId: incident.tripId,
        driverId: incident.driverId,
      },
    });
    this.mixpanelService.track('Clicked view trip details in safety events ', {
      'Event Type': incident.eventTypeLabel,
      'Driver ID': incident.driverId,
    });
  }

  public onDownloadVideos(incident: any): void {
    this.downloadService.onDownloadVideos(incident);
  }

  private updateIncident(tripId, events: any, updateType: string, showSnackbar) {
    events.forEach((element) => {
      element.actionLoader = true;
    });
    const { loginName: userEmail, name: userName } = this.accessService.getLoginInfo();
    const params = {
      tripId,
      driverId: events?.[0]?.driverId,
      events: events.map((e) => {
        return {
          eventIndex: e.eventIndex,
          ...(updateType === 'REPORT_BUG' && {
            reportBug: true,
            challengeRaised: true,
            challengeAccepted: true,
            challengeResolved: true,
          }),
          ...(updateType === 'COACHING' && {
            bookmark: true,
            coachingCompleted: false,
            coachingInitiatedMetadata: {
              userType: 'FLEET_MANAGER',
              email: userEmail,
              name: userName,
            },
          }),
          ...(updateType === 'VIEWED_STATUS' && { isViewed: true }),
        };
      }),
    };
    this.dataService
      .updateEventMetadata(params)
      .pipe(
        finalize(() => {
          events.forEach((element) => {
            element.actionLoader = false;
          });
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(
        () => {
          if (updateType === 'REPORT_BUG') {
            events.forEach((element) => {
              element.reportBug = true;
            });
          } else if (updateType === 'COACHING') {
            events.forEach((element) => {
              element.bookmark = true;
            });
          } else if (updateType === 'VIEWED_STATUS') {
            events.forEach((element) => {
              element.isViewed = true;
            });
          }
          if (showSnackbar) {
            this.snackbarService.success(`${this.translate.instant('commonIncidentViewUpdatedSuccessfully')}`);
          }
        },
        () => {
          if (showSnackbar) {
            this.snackbarService.failure(`${this.translate.instant('commonIncidentViewUpdateFailed')}`);
          }
        }
      );
  }

  private generateDataChunk(data: any, chunk = 3) {
    let index: number;
    let dataChunk: [][] = [];
    for (index = 0; index < data.length; index += chunk) {
      dataChunk.push(data.slice(index, index + chunk));
    }
    return dataChunk;
  }

  private getTagsQueryParams() {
    let params = {};
    if (this.tagIds && this.tagIds.length) {
      params['tagIds[]'] = this.tagIds;
    }
    return params;
  }

  public toggleFilter() {
    this.isFilterVisible = !this.isFilterVisible; // Toggle the filter card visibility
  }

  public toggleView() {
    this.store.dispatch(new UpdateIncidentViewType({ isListView: !this.isListView }));
    this.clearSelection();
  }

  private mapIncidentSeverity(rows = [], totalCount = 0) {
    const incidentsWithSeverity = rows.map((incident) => {
      if (!EVENT_SEVERITY_TYPE_LIST[incident.eventType]) {
        return incident;
      }

      let low, high, severity;
      if (incident.originalEventType === 'MaxSpeedExceeded') {
        ({ low, high, severity } = EVENT_SEVERITY_TYPE_LIST[incident.originalEventType]);
      } else {
        ({ low, high, severity } = EVENT_SEVERITY_TYPE_LIST[incident.eventType]);
      }

      const severityValue = severity(incident);
      const severityCategory = this.dataService.assignSeverityType(severityValue, low, high);

      let textColor = '';
      let backgroundColor = '';

      if (severityCategory === 'HIGH') {
        textColor = HIGH_COLOR.text;
        backgroundColor = HIGH_COLOR.background;
      } else if (severityCategory === 'MEDIUM') {
        textColor = MEDIUM_COLOR.text;
        backgroundColor = MEDIUM_COLOR.background;
      } else {
        textColor = LOW_COLOR.text;
        backgroundColor = LOW_COLOR.background;
      }

      return {
        ...incident,
        severityValue,
        severityCategory,
        textColor,
        backgroundColor,
      };
    });

    return {
      rows: incidentsWithSeverity,
      totalCount,
    };
  }

  private verifyAndUpdateTablePageSize(event: PageEvent) {
    if (event.pageSize !== this.tablePageSize) {
      this.tablePageSize = (event as PageEvent).pageSize;
      this.dataService.currentTablePageSize = this.tablePageSize;
      this.accessService.currentTablePageSize = this.tablePageSize;
      this.updateUserMetadata({
        incidentsTablePageSize: this.tablePageSize,
      });
      this.dataSource.data = new Array(this.tablePageSize).fill(undefined);
      this.paginator.firstPage();
    }
  }

  public updateUserMetadata(metadata: any) {
    if (window.self != window.top) {
      const { userMetadata: oldMetadata = {} } = this.accessService.getLoginInfo();
      const userPrefChangedMessage = {
        type: 'user_preferences_changed',
        userPreferences: {
          ...oldMetadata,
          ...metadata,
        },
      };
      window.parent.postMessage(userPrefChangedMessage, '*');
      return;
    }
    const params = {
      ...metadata,
    };
    const { loginType = '', userId = '' } = this.accessService.getLoginInfo();
    this.userManageService
      .updateUser(userId, new UpdateUserMetadataReqBody(params), loginType)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        () => {},
        () => {}
      );
  }

  public isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  public masterToggle(): void {
    this.selectedRowCount = this.selection.selected.length;
    if (this.isAllSelected()) {
      this.clearSelection();
    } else {
      this.selection.select(...this.dataSource.data);
    }
    this.selectedRowCount = this.selection.selected.length;
    this.selectedEvents = [...this.selection.selected];
  }
  // /** The label for the checkbox on the passed row */
  public checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }
  public clearSelection() {
    this.selection.clear();
    this.selectedEvents = [];
    this.selectedRowCount = null;
  }

  public toggleSelection(row: any) {
    this.selection.toggle(row);
    this.selectedRowCount = this.selection.selected.length;
    this.selectedEvents.push(row);

    if (this.selection.isSelected(row)) {
      this.onMenuItemClick(row);
    }
    if (this.selectedRowCount === 0) {
      this.clearSelection();
    }
  }

  public onMenuItemClick(incidentDetails) {
    this.selectedItem = incidentDetails;
    const incidents = this.selectedEvents;
    this.selectedCount = this.selection.selected.length;
    const incidentsByTripId: { [key: string]: any[] } = incidents.reduce((a, b) => {
      return {
        ...a,
        [b.tripId]: [...(a[b.tripId] || []), b],
      };
    }, {});
    Object.entries(incidentsByTripId).forEach(([tripId, events], index, arr) => {
      if (incidentDetails.action === 'SELECT_FOR_COACHING') {
        const filteredEvents = events.filter((e) => e.enableSelectForCoaching && !e.bookmark && !e.challengeRaised);
        this.clearSelection();
        this.coachIncident(tripId, filteredEvents, index === arr.length - 1);
      } else if (incidentDetails.action === 'DISCARD_EVENTS') {
        const filteredEvents = events.filter((e) => !e.bookmark && !e.reportBug);
        this.clearSelection();
        this.discardIncident(tripId, filteredEvents, index === arr.length - 1);
      } else if (incidentDetails.action === 'MARK_AS_VIEWED') {
        events.forEach((incidentDetails) => {
          this.gtmService.incidentViewedListStatus(incidentDetails.eventTypeLabel, incidentDetails.asset.assetId);
        });
        const filteredEvents = events.filter((e) => !e.isViewed);
        incidents.isViewed = true;
        this.clearSelection();
        this.updateIncident(tripId, filteredEvents, 'VIEWED_STATUS', index === arr.length - 1);
      }
    });
  }

  public playVideo(video: HTMLVideoElement, incident: any): void {
    if (video && video.paused) {
      incident.playPromise = video.play().catch((e) => console.error(e));
    }
  }

  public pauseVideo(video: HTMLVideoElement, incident: any): void {
    if (video && !video.paused && incident.playPromise) {
      incident.playPromise.then((_) => video.pause());
    }
    incident.isHovering = false;
  }

  private getIncidentDetailsAndOpenDialog(options: IncidentDetailsParams) {
    this.incidentsService.getIncidentDetailsAndOpenDialog(options).pipe(takeUntil(this.ngUnsubscribe)).subscribe();
  }

  public onPlaybackError(incident) {
    incident.mediaNotAvailable = true;
  }
}
